import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { config } from '../../../config/pages-config';
import { RouterService } from '../services/router.service';
/** DisableDeepLinksGuard */
@Injectable()
export class DisableDeepLinksGuard implements CanActivate {
    /**
     *
     * @param router
     * @param routerService
     */
    public constructor (private router: Router, private routerService: RouterService) { }

  /**
   * canActivate is checking if the use came from deeplink or not
   * if the use came from deeplink then we will navigate him to login page
   * @param route - snapshot of current route data
   * @param state - snapshot of current state data
   * @returns {Observable<boolean>}
   */
    public canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (!this.routerService.previousExist) {

            this.router.navigate([config.landingPage.route], {queryParams: {
                logout: false,
            }});

            return false;
        }

        return true;
    }

}
